import { UIGameAnimationBase } from './UIGameAnimationBase.ts';
import { uiGameManager } from '../../EntryShared.ts';
import { isCloseTo } from '../../ui_utils/Utils.ts';
import { Point } from '@colonist/game-mechanic-validators';
export class UIGameGoToPointAnimation extends UIGameAnimationBase {
    start() {
        this.totalDistance = this.calculateDiagonalDistanceToDestination();
        this.velocity = UIGameGoToPointAnimation.calculateVelocity(this.speed);
        super.start();
        return this;
    }
    onGameTick(deltaTime, elapsedMS) {
        if (this.viewToAnimate.destroyed) return this.stop();
        const isCloseToCompleteX = isCloseTo(this.viewToAnimate.x, this.destinationPoint.x, this.velocity * deltaTime);
        const isCloseToCompleteY = isCloseTo(this.viewToAnimate.y, this.destinationPoint.y, this.velocity * deltaTime);
        const distanceX = this.destinationPoint.x - this.viewToAnimate.x;
        const distanceY = this.destinationPoint.y - this.viewToAnimate.y;
        const diagonalDistance = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
        this.completionPercentage = 1 - diagonalDistance / this.totalDistance;
        if (isCloseToCompleteX && isCloseToCompleteY || diagonalDistance < this.COMPLETION_MARGIN) {
            this.stop();
            return;
        }
        const normalizedDirectionVectorX = distanceX / diagonalDistance;
        const normalizedDirectionVectorY = distanceY / diagonalDistance;
        const currentFrameMovementAmount = Math.min(this.velocity * deltaTime, diagonalDistance);
        this.viewToAnimate.x += normalizedDirectionVectorX * currentFrameMovementAmount;
        this.viewToAnimate.y += normalizedDirectionVectorY * currentFrameMovementAmount;
    }
    /** @deprecated Only added to be re-compatible with ViewAnimationController */ setSpeed(speed) {
        this.speed = speed;
        return this;
    }
    /** @deprecated Only added to be re-compatible with ViewAnimationController */ setDestination(destination) {
        this.destinationPoint.x = destination.x;
        this.destinationPoint.y = destination.y;
        return this;
    }
    calculateDiagonalDistanceToDestination() {
        const distance = this.calculateDistanceToDestination();
        const diagonalDistance = Math.sqrt(distance.x * distance.x + distance.y * distance.y);
        return diagonalDistance;
    }
    calculateDistanceToDestination() {
        const distanceX = this.destinationPoint.x - this.viewToAnimate.x;
        const distanceY = this.destinationPoint.y - this.viewToAnimate.y;
        return new Point(distanceX, distanceY);
    }
    static calculateVelocity(speed) {
        const { appW, appH } = uiGameManager.canvasController;
        const appSize = Math.max(appW, appH);
        return speed * appSize / 125;
    }
    resetToDefaultState() {
        if (this.viewToAnimate.destroyed) return;
        this.viewToAnimate.x = this.destinationPoint.x;
        this.viewToAnimate.y = this.destinationPoint.y;
        this.completionPercentage = 1;
    }
    constructor(viewToAnimate, destinationPoint, speed = 1){
        super(), this.forceEnableAnimation = false, this.completionPercentage = 0, this.COMPLETION_MARGIN = 0.1;
        this.viewToAnimate = viewToAnimate;
        this.destinationPoint = destinationPoint;
        this.speed = speed;
    }
}
